/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_TitleInputs */

const es_chat_share_modal_title = /** @type {(inputs: Chat_Share_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Chat compartido!`)
};

const en_chat_share_modal_title = /** @type {(inputs: Chat_Share_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat shared!`)
};

/**
* | output |
* | --- |
* | "Chat shared!" |
*
* @param {Chat_Share_Modal_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_title = /** @type {((inputs?: Chat_Share_Modal_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_title(inputs)
	return en_chat_share_modal_title(inputs)
});
export { chat_share_modal_title as "chat.share_modal.title" }